import { render, staticRenderFns } from "./ipadMange.vue?vue&type=template&id=2a5b4e54&scoped=true&"
import script from "./ipadMange.vue?vue&type=script&lang=js&"
export * from "./ipadMange.vue?vue&type=script&lang=js&"
import style0 from "./ipadMange.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ipadMange.vue?vue&type=style&index=1&id=2a5b4e54&scoped=true&lang=css&"
import style2 from "./ipadMange.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b4e54",
  null
  
)

export default component.exports